
import { mapState } from 'vuex'
import { diagramToAnalyticsItem } from '@/utils/helpers'

export default {
  transition: 'page',
  data () {
    return {
      loading: false,
      adding: [],
      removing: [],
      showModal: false,
      relatedDiagrams: null,
      cartItem: null,
      showLabel: false,
      listName: 'Favourite diagrams'
    }
  },
  head () {
    return {
      title: 'infoDiagram - Wishlist',
      bodyAttrs: {
        class: 'page-wishlist'
      }
    }
  },
  mounted () {
    const diagrams = this.wishlist.map(w => w.diagram)
    const items = diagrams.map(
      (diagram, index) => ({
        ...diagramToAnalyticsItem(diagram, index),
        list_name: this.listName
      })
    )
    this.$gtag.event('view_item_list', { items })
  },
  computed: mapState('favourites', ['wishlist'])
}
